<template>
  <ion-page>
    <master-layout @refreshPage="reRender" pageTitle="مشاهده مأموریت">
      <div v-if="mission">
        <IonCardContent>
          <input type="checkbox" name="just_not_visited" v-model="just_not_visited" id="just_not_visited" :checked="just_not_visited"><label class="mr-2" for="just_not_visited">نمایش ویزیت نشده ها</label>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
              <tr>
                <th>مشتری</th>
                <th>وضعیت</th>
                <th>امکانات</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(x,index) in mission_items" :key="index">
                <td>
                  {{(x.customer?x.customer.fullname:'--')}}
                </td>
                <td>{{(x.is_visit?'ویزیت شده':'ویزیت نشده')}}</td>
                <td><router-link class="btn btn-info" :to="'/mission/customerInfo/'+x._id"><i class="far fa-edit"></i></router-link>
                &nbsp;<a v-if="x.customer && x.customer.lat" :href="'geo:'+x.customer.lat+','+x.customer.lng" class="btn btn-success"><i class="far fa-directions"></i></a>&nbsp;
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </IonCardContent>
        <ion-card-content class="p-0">
          <div id="map_div4" ref="map_div4">
          </div>
          <br>
          <div class="marker-note-box">
            <div class="marker-note">
              <img src="/assets/img/order-marker.png">&nbsp;
              <p>مأموریت های ویزیت شده به همراه ثبت سفارش</p>
            </div>
            <div class="marker-note">
              <img src="/assets/img/reject-marker.png">&nbsp;
              <p>مأموریت های ویزیت شده بدون ثبت سفارش</p>
            </div>
            <div class="marker-note">
              <img src="/assets/img/no-visit-marker.png">&nbsp;
              <p>مأموریت های ویزیت نشده</p>
            </div>
          </div>
        </ion-card-content>
      </div>
    </master-layout>
  </ion-page>
</template>

<script>
import L from "leaflet";
require('leaflet.locatecontrol');
import {mapActions} from "vuex";
import {IonPage,IonCardContent} from '@ionic/vue';
export default {
name: "view",
  components: { IonPage,IonCardContent},
  data()
  {
    return{
      id: null,
      mission: null,
      mission_items: [],
      map: null,
      markers: null,
      map_html : '',
      just_not_visited : false,
    }

  },
  async mounted()
  {
    // console.log(this.map_html)
    await this.init();
  },
  methods: {
    async init()
    {
      const self = this;
      this.id = this.$route.params.id;
      const result = await this.getMission(this.id);
      if(result.ok)
      {
        this.mission = result.mission;
        const items = result.items;
        let end_items = [];
        if (this.just_not_visited)
        {
          for (let i = 0; i < items.length; i++)
          {
            const item = items[i];
            if (!item.is_visit)
              end_items.push(item);
          }
        }
        else
          end_items = items;
        this.mission_items = end_items;


        setTimeout(function (){
          self.initMap();
          const places = end_items;
          for (let i = 0; i < places.length; i++)
          {
            if (places[i].location && places[i].location.coordinates && places[i].location.coordinates[0] && places[i].location.coordinates[1])
            {
              let iconUrl = '';

              if(places[i].is_visit && places[i].reason_ids)
                iconUrl = '/assets/img/reject-marker.png';
              else if(places[i].is_visit && places[i].order_id)
                iconUrl = '/assets/img/order-marker.png';
              else if(!places[i].is_visit)
                iconUrl = '/assets/img/no-visit-marker.png';
              else
                iconUrl = '/assets/img/reject-marker.png';



              self.placeMarker({
                latlng: {
                  lat:places[i].location.coordinates[1],
                  lng:places[i].location.coordinates[0],
                }
              },places[i]._id,places[i].customer,iconUrl)
            }
          }
        },1000)
      }
    },
    ...mapActions('mission',{
      getMission:'getMission',
    }),
    initMap()
    {
      this.map_html = this.$refs['map_div4'];
      this.map_html.innerHTML = '<div id="map4" style="height: 300px"></div>';

      let m = this.mission_items[0];

      var lat= (m?m.location.coordinates[1]:36.314571865811935) , lng= (m?m.location.coordinates[0]:59.57267761230469);
      var zoom=12;
      var osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          osmAttrib = '&copy; <a href="https://carencar.com">کارن کار</a>',
          osm = L.tileLayer(osmUrl, {maxZoom: 18, attribution: osmAttrib});
      this.map = L.map('map4',{ zoomControl: true, dragging: true, boxZoom: true, scrollWheelZoom: true }).setView([lat,lng], zoom).addLayer(osm);
      L.control.locate({
        drawCircle: true, // controls whether a circle is drawn that shows the uncertainty about the location
        setView: true, // automatically sets the map view to the user's location, enabled if follow is true
        follow:true,
        flyTo:true,
        keepCurrentZoomLevel: false, // keep the current map zoom level when displaying the user's location. (if false, use maxZoom)
        circlePadding: [0, 0], // padding around accuracy circle, value is passed to setBounds
        locateOptions: {
          maxZoom: 15
        },
        strings: {
          title: "نمایش موقعیت فعلی", // title of the locate control
          popup: "موقعیت فعلی شما", // text to appear if user clicks on circle
          outsideMapBoundsMsg: "بنظر میاد شما در خارج از این کره خاکی هستید" // default message for onLocationOutsideMapBounds
        }
      }).addTo(this.map);


    },
    placeMarker(e,id,customer,iconUrl)
    {
      const self = this;

      const markerIcon = new L.Icon({
        iconUrl: iconUrl,
        iconSize:     [30, 46],
      });
      this.markerHolder = new L.marker(e.latlng,{icon:markerIcon})
      if (customer)
      {
        console.log('okkkkkk')
        this.markerHolder.on('click', function ()
        {
          // const id2 = "'"+id+"'";
          const html = '<div style="text-align: center">' +
              customer.fullname +
              '</div><a href="geo:' + customer.lat + ',' + customer.lng + '" class="btn btn-info btn-block mt-1" ><i class="far fa-directions"></i></a>'
          L.popup()
              .setLatLng(e.latlng)
              // .setContent('<div class="center"> <b style="margin-bottom: 5px;display: block;">'+fullname+'</b><div><button onclick="window.page.showCustomerInfo('+id2+')" class="btn btn-info">مشاهده اطلاعات</button></div></div>')
              .setContent(html)
              .openOn(self.map);
          // self.$router.push({path : '/mission/customerInfo/'+id})
        })
      }
      this.markerHolder.addTo(this.map);
      this.lat = e.latlng.lat;
      this.lng = e.latlng.lng;

    },
    showMissionItemInfo(id)
    {
      this.$router.push('/mission/customerInfo/'+id);
    },
    reRender()
    {
      this.init();
    }
  },
  watch:{
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('mission/view/') >= 0 && oldUrl.toLowerCase().indexOf('mission/view/') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
    just_not_visited(){
      this.init();
    }
  }
}

</script>

<style scoped>
.mr-2
{
  margin-right: 5px;
}
#map {
  height: 400px;
  direction: ltr;
}
.marker-note-box {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
}
.marker-note {
  display: flex;
  margin-bottom: 5px;
}
.marker-note p {
  font-size: 13px;
}
.marker-note img {
  width: 15px;
}
.p-0
{
  padding: 0!important;
}
.mt-1
{
  margin-top: 5px;
}
</style>